export default __webpack_public_path__ + "static/media/copy_link.cb3ea102.svg";